import React, { useEffect, useState } from 'react'
import BbtbCharts from './BbtbCharts'
import apiService from 'apiService';
import Tbu from './Tbu';
import Bbu from './Bbu';
import LingkarKepala from './LingkarKepala';


const GrafikTumbuhKembang = (props) => {
    const [history, sethistory] = useState([])
    const getHistories = async () => {
        const res = await apiService.get(
            "registration/history/" + props.detilPx.patients.id
        );
        if (res.code === 200) {
            let histories = res.data.histories.data.reverse();
            sethistory(histories)
        }
    };
    useEffect(() => {
        getHistories()
    }, [history.length])
    return (
        <div>
            <div className="card">
                <BbtbCharts data={history} />
                <Tbu />
                <Bbu />
                <LingkarKepala />
            </div>
        </div>
    )
}

export default GrafikTumbuhKembang